import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Category } from '@/types/category'

export function getCategories(
  includeDeleted?: boolean
): Promise<AxiosResponse<Category[]>> {
  return instance.get(`/category`, { params: { includeDeleted } })
}
